export type NotificationEventType =
  | import('modules/global/typing/enums/appointment.events.enum').AppointmentEventTypeEnum
  | import('@arhs-fleetback/types/entities/audits').AuditEventType
  | any // CampaignFileEntityEventEnum
  | any // CampaignEventTypeEnum
  | any // ContactListEventTypeEnum
  | any // ConversationEventTypeEnum
  | import('modules/global/typing/enums/interventions.enum').InterventionEventTypeEnum
  | any; // GuidelineEventTypeEnum

export const NotificationStatus = {
  READ: 'READ',
  UNREAD: 'UNREAD'
} as const;

export type NotificationStatus = typeof NotificationStatus[keyof typeof NotificationStatus];

export const Channel = {
  WEB: 'WEB',
  DESKTOP: 'DESKTOP',
  EMAIL: 'EMAIL',
  MOBILE: 'MOBILE'
} as const;

export type Channel = typeof Channel[keyof typeof Channel];

export const NotificationType = {
  ALL: 'ALL',
  ONLY_ME: 'ONLY_ME',
  NONE: 'NONE'
} as const;

export type NotificationType = typeof NotificationType[keyof typeof NotificationType];

export const NotificationSettingSelect = {
  ALL: 'ALL',
  MINE: 'MINE'
} as const;

export type NotificationSettingSelect = typeof NotificationSettingSelect[keyof typeof NotificationSettingSelect];

export const NotificationExtension = {
  AFTER_SALES: 'AFTER_SALES',
  APPOINTMENT: 'APPOINTMENT',
  AUDIT: 'AUDIT',
  BODYWORK_APPOINTMENT: 'BODYWORK_APPOINTMENT',
  CHAT: 'CHAT',
  PARTS: 'PARTS',
  REMINDER: 'REMINDER',
  SALES: 'SALES',
  SELF_SERVICE: 'SELF_SERVICE'
} as const;

export type NotificationExtension = typeof NotificationExtension[keyof typeof NotificationExtension];

export const NotificationSetting = {
  ACCEPTED: 'ACCEPTED',
  ANSWERED: 'ANSWERED',
  ASSIGNED: 'ASSIGNED',
  ASSIGNEE_CHANGED: 'ASSIGNEE_CHANGED',
  COMPLETED: 'COMPLETED',
  CREATE: 'CREATE',
  CREATED: 'CREATED',
  CUSTOMER_INFO_UPDATED: 'CUSTOMER_INFO_UPDATED',
  CUSTOM_STEP_CHANGED: 'CUSTOM_STEP_CHANGED',
  DOCUMENT_SIGNED: 'DOCUMENT_SIGNED',
  DOCUMENT_UPDATED: 'DOCUMENT_UPDATED',
  DUPLICATED: 'DUPLICATED',
  RATED: 'RATED',
  SERVICE_ADVISOR_ASSIGNED: 'SERVICE_ADVISOR_ASSIGNED',
  UNSUBSCRIBE: 'UNSUBSCRIBE',
  ISSUE_REPORTED: 'ISSUE_REPORTED',
  KPI_ANSWERED: 'KPI_ANSWERED',
  LEAD_CREATED: 'LEAD_CREATED',
  MESSAGE_CREATED: 'MESSAGE_CREATED',
  PAID: 'PAID',
  PAYMENT: 'PAYMENT',
  PAYMENT_DEPOSIT_SUCCESS: 'PAYMENT_DEPOSIT_SUCCESS',
  PAYMENT_SUCCESS: 'PAYMENT_SUCCESS',
  READ: 'READ',
  REJECTED: 'REJECTED',
  REOPENED: 'REOPENED',
  RENTAL_SIGNED: 'RENTAL_SIGNED',
  MOBILITY_DOCUMENT_MEDIA_ADDED: 'MOBILITY_DOCUMENT_MEDIA_ADDED',
  MOBILITY_DOCUMENT_MEDIA_FRAUD_DETECTED: 'MOBILITY_DOCUMENT_MEDIA_FRAUD_DETECTED',
  MOBILITY_REFUSED: 'MOBILITY_REFUSED',
  SELF_SERVICE_ANSWERED_MANUAL_CHECK_OUT: 'SELF_SERVICE_ANSWERED_MANUAL_CHECK_OUT',
  SELF_SERVICE_HOME_CHECK_IN_COMPLETED: 'SELF_SERVICE_HOME_CHECK_IN_COMPLETED',
  SELF_SERVICE_ON_SITE_CHECK_IN_COMPLETED: 'SELF_SERVICE_ON_SITE_CHECK_IN_COMPLETED',
  SELF_SERVICE_KIOSK_CHECK_IN_COMPLETED: 'SELF_SERVICE_KIOSK_CHECK_IN_COMPLETED',
  SELF_SERVICE_HOME_CHECK_OUT_COMPLETED: 'SELF_SERVICE_HOME_CHECK_OUT_COMPLETED',
  SELF_SERVICE_ON_SITE_CHECK_OUT_COMPLETED: 'SELF_SERVICE_ON_SITE_CHECK_OUT_COMPLETED',
  SELF_SERVICE_KIOSK_CHECK_OUT_COMPLETED: 'SELF_SERVICE_KIOSK_CHECK_OUT_COMPLETED',
  SELF_SERVICE_MANUAL_CHECK_OUT_COMPLETED: 'SELF_SERVICE_MANUAL_CHECK_OUT_COMPLETED',
  SELF_SERVICE_EXTRAS_ACCEPTED: 'SELF_SERVICE_EXTRAS_ACCEPTED',
  SELF_SERVICE_BREAKDOWN_CREATED: 'SELF_SERVICE_BREAKDOWN_CREATED',
  SELF_SERVICE_COMMENT_ADDED: 'SELF_SERVICE_COMMENT_ADDED',
  SELF_SERVICE_PROACTIVES_ACCEPTED: 'SELF_SERVICE_PROACTIVES_ACCEPTED',
  SELF_SERVICE_QUESTION_ANSWERED: 'SELF_SERVICE_QUESTION_ANSWERED',
  SELF_SERVICE_QUESTION_COMMENTED: 'SELF_SERVICE_QUESTION_COMMENTED',
  SELF_SERVICE_SLOT_EMPTIED: 'SELF_SERVICE_SLOT_EMPTIED',
  SELF_SERVICE_SLOT_FILLED: 'SELF_SERVICE_SLOT_FILLED',
  STARTED: 'STARTED',
  STEP: 'STEP',
  VAULT_UPDATED: 'VAULT_UPDATED'
} as const;

export type NotificationSetting = typeof NotificationSetting[keyof typeof NotificationSetting];
